import { useEffect } from 'react';
import { Stack } from '@mantine/core';
import { AuditTct } from '@dealstack/shared/lib/generated';
import { TimelineAuditCard } from '@dealstack/frontend/shared/components/Audit/AuditLayout/AuditCard.tsx';

interface Props {
	audits: AuditTct[];
	selectedAuditId?: string | null;
	setSelectedAuditId?: (id: string) => void;
	showTableName?: boolean;
}

export const AuditsList = ({
	audits,
	selectedAuditId,
	setSelectedAuditId,
	showTableName,
}: Props) => {
	useEffect(() => {
		if (!selectedAuditId && audits.length > 0) {
			setSelectedAuditId?.(audits[0].id);
		}
	}, [selectedAuditId, audits, setSelectedAuditId]);

	return (
		<Stack gap="1.25rem">
			{audits.map((audit, idx) => (
				<TimelineAuditCard
					key={audit.id}
					audit={audit}
					isSelected={audit.id === selectedAuditId}
					onCardClick={setSelectedAuditId}
					showDivider={idx !== audits.length - 1}
					showTableName={showTableName}
				/>
			))}
		</Stack>
	);
};
